import {rule} from '@/util/validateRules'

export const channelLogOption = (safe) => {
	return {
		card: true,
		stripe: true,
		border: true,
		align: 'center',
		menuAlign: 'center',
		searchMenuPosition: 'right',
		menuWidth: 140,
		gutter: 20,
		searchMenuSpan: 18,
		labelWidth: 120,
		page: false,
		addBtn: false,
		editBtn: false,
		delBtn: false,
		menu: false,

		column: [
			{
				label: 'commitId',
				prop: 'commitId',
				width: 100,
			},
			{
				label: '操作人',
				prop: 'author',
				width: 120,
			},
			{
				label: '操作时间',
				prop: 'changeTime',
				type: 'datetime',
				format: 'yyyy-MM-dd HH:mm:ss',
				valueFormat: 'yyyy-MM-dd HH:mm:ss',
				width: 160,
			},
			{
				label: '修改内容',
				prop: 'content',
				// overHidden: true,
				minWidth: 500,
				html: true,
			},
		],
	}
}
